import { trackLinkEvent, yieldToMainBackground } from "../../common/utils";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	// preview immagini nella scheda
	const gallery_preview = document.querySelector("#_gallery-preview");
	if (gallery_preview) {
		import("../../common/image_gallery.js").then((module) => {
			const MovieFreeGLightbox = module.MovieFreeGLightbox;
			const images = [];
			for (const el of document.querySelectorAll("._gallery_img")) {
				images.push({ href: el.dataset.gallerySrc });
			}
			new MovieFreeGLightbox({
				elements: images,
				selector: "#_gallery-preview ._gallery_img",
			});
		});
	}

	// tracciamento streaming
	for (const el of document.querySelectorAll("._streaming_data a")) {
		el.addEventListener("click", () => {
			yieldToMainBackground().then(() => {
				trackLinkEvent("streaming-data-link");
			});
		});
	}

	if (document.querySelector("#news")) {
		// Aggiornamento data articoli
		import("../../common/pubdate.js");
	}

	// lightbox cast
	document.querySelector("#_film_cast")?.addEventListener("click", (event) => {
		event.preventDefault();
		const target = event.currentTarget;
		fetch(`/misc/cast/${target.dataset.ct}/${target.dataset.id}/`, {
			headers: {
				"X-Requested-With": "XMLHttpRequest",
			},
			cache: "no-cache",
		})
			.then((response) => {
				if (response.status === 200) {
					return response.text();
				}
				console.warn(" --- Error: ", response.statusText);
			})
			.then((data) => {
				if (data) {
					import("basiclightbox").then((basicLightbox) => {
						const castLightbox = basicLightbox.create(data);
						castLightbox.show();
					});
				}
			})
			.catch((error) => {
				console.warn(error);
			});
	});

	// lightbox curiosità
	document.querySelector("#_obj_trivia")?.addEventListener("click", (event) => {
		event.preventDefault();
		const target = event.currentTarget;
		fetch(`/misc/trivia/${target.dataset.ct}/${target.dataset.id}/`, {
			headers: {
				"X-Requested-With": "XMLHttpRequest",
			},
			cache: "no-cache",
		})
			.then((response) => {
				if (response.status === 200) {
					return response.text();
				}
				console.warn(" --- Error: ", response.statusText);
			})
			.then((data) => {
				if (data) {
					import("basiclightbox").then((basicLightbox) => {
						const triviaLightbox = basicLightbox.create(data);
						triviaLightbox.show();
					});
				}
			})
			.catch((error) => {
				console.warn(error);
			});
	});
});
